export default "__VITE_ASSET__CP15ZEsc__"